import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#000";
function RBTC({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" strokeMiterlimit={10} fill={color}><path d="M9.614 5.704a2.386 2.386 0 114.773 0 2.386 2.386 0 01-4.773 0" /><path d="M18.64 13.081a2.386 2.386 0 00-3.579 2.122c.024 1.051-.922 1.599-1.82 1.056l-.11-.063c-.91-.508-.909-1.589.001-2.096a2.39 2.39 0 001.252-2.1l-.002-.054.001.001c-.023-1.053.925-1.6 1.825-1.052a2.386 2.386 0 003.307-3.234 2.387 2.387 0 00-4.453 1.247c.024 1.051-.921 1.598-1.82 1.056a2.37 2.37 0 00-1.244-.35c-.456 0-.882.128-1.244.35-.896.54-1.839-.006-1.815-1.055a2.387 2.387 0 10-1.146 1.986c.898-.545 1.843 0 1.82 1.051v-.001L9.612 12c0 .907.506 1.696 1.251 2.1.91.507.91 1.59 0 2.096l-.109.063c-.896.54-1.838-.007-1.814-1.056a2.387 2.387 0 10-1.192 2.01l.043-.027-.001.002c.899-.545 1.845.002 1.82 1.052h.001l-.001.058a2.386 2.386 0 104.773-.005l-.002-.053.001.002c-.024-1.054.925-1.601 1.826-1.054l-.002-.002.049.03a2.386 2.386 0 102.384-4.135" /></Svg>;
}
RBTC.DefaultColor = DefaultColor;
export default RBTC;